import React from "react";

const ErrorBanner = ({ error }) => {
  if (!error) return null;
  return (
    <div className="mb-4 rounded-md border border-rust-200 bg-rust-50 px-3 py-2 text-sm text-rust-700">
      {error}
    </div>
  );
};

export default React.memo(ErrorBanner);
